import React from 'react';
import { connect } from 'react-redux';
import OrganisationsTable from '../components/Organisations/OrganisationsTable';
import Breadcrumb from '../components/Common/Breadcrumb';
import { isGroupParentOrg } from '../components/utils/managementShell';

const Organisations = ({ groupParentMode }) => {
  return (
    <React.Fragment>
      <Breadcrumb
        items={[
          {
            label: groupParentMode ? 'Group organisations' : 'Organisations',
            link: '/organisations',
          },
        ]}
      />

      <OrganisationsTable />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const orgDetails = state?.organisation?.details;
  const orgList = [...(state.organisation?.list || []), ...(state.admin?.organisations || [])];
  return {
    groupParentMode: isGroupParentOrg(orgDetails, orgList),
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Organisations);
